export default{
    currency:'واحد پول',
    currencyTitle: 'عنوان',
    currencyStatus: 'وضعیت',
    currencies:'مدیریت واحدهای پولی',
    editCurrency:'ویرایش واحد پول',
    addCurrency:'واحد پول جدید',

}